import { instantsInterceptor, } from '@/api/index';

function productList(form) {
    return instantsInterceptor.post('/service/product/list', form);
}

export { productList };